import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon} from 'tinper-bee';
import { observer } from 'mobx-react';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _truncate from 'lodash/truncate';
import classnames from 'classnames'
import { history, stores } from 'mutants-microfx';
import {User} from 'tplus-api';
import { PosInitData } from 'tplus-poslogin';
import { ModalWraper,Message,Ticon,modalShower } from 'tplus-components-touch'
import { PayStyle,PayIcon,getFixedNumber,getQuantity } from './utils'
import TipNumKbModalVertical from '../components/tipNumKbModalVertical'
import common from '../util/common.js'
import MemberApi from '../api/MemberApi.js'
import PwdModal from './pwd.js'
import Popover from './popover.js'


@observer
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
            showModal: false,
            showPwd:false,
            // isOpen:false,
        };
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
	}

	getQueryString(search,type) {
		let reg = new RegExp("(^|&)" + type + "=([^&]*)(&|$)","i");
		let r = search.substr(1).match(reg);
		if (r!=null) return (r[2]); return null;
	}


	close() {
        this.setState({
            showModal: false
        });
    }
    open() {
        this.setState({
            showModal: true
        });
    }

	static contextTypes = {
		stores: PropTypes.object
	};

	componentWillMount() {
		let { selfSettlementStore } = this.context.stores;
        this.store = selfSettlementStore;
	}

	componentDidMount() {
        this.store.getPaymodes();
        this.store.init(stores.voucherStore);
        this.bindBodyClick();
    }
    componentWillUnmount() {
        this.removeBodyClick()
    }
    bindBodyClick=()=>{
        var _this = this;
        setTimeout(() => {
            common.setFocus();
            document.body.addEventListener("click", common.activeEl)
            _this.getInput();
        }, 0)
    }
    removeBodyClick=()=>{
        document.body.removeEventListener("click", common.activeEl)
    }
    getInput() {
        const el = document.querySelector('.active-el');
        console.log("get input ..........")
        const _this = this;
        let code = "";
        let lastTime, nextTime;
        let lastCode, nextCode;

        el.onkeypress = function (e) {
            nextCode = e.which;
            nextTime = new Date().getTime();
            if (lastCode != null && lastTime != null && nextTime - lastTime <= 30) {
                code += String.fromCharCode(lastCode);
            } else if (lastCode != null && lastTime != null && nextTime - lastTime > 100) {
                code = "";
            }
            lastCode = nextCode;
            lastTime = nextTime;

            if (e.which == 13) {
                console.log("付款码信息" + `${code}`)
                let barcode = code;
                code = "";
                _this.addInvent(barcode)
            }
        }
    }
    addInvent = (val) => {
        const input = val || "";
        if (!input) {
            Message.toast('请输入付款码')
            return;
        }
        this.store.authCode=input;
        this.handleSettle();
    }
    renderLeft() {
        return <div className='member-input-left'>
            <span>
                请将会员卡
            </span>
            <br />
            <span>
                对准右下方扫描口
            </span>
        </div>
    }
    searchMember=(input)=> {
        MemberApi.getSearchMember({
            currentPage: 1,
            pageSize: 10,
            key: input,
            isSingleMember: true,
        }).then(ret => {
            const { ColumnInfo: columnInfo, Data } = ret || {};
            const data = JSON.parse(Data) || [];
            const info = data[0];
            if (info) {
                this.setState({ showModal: false })
                // controllerEvent('changeMember', info)
                this.store.setMember(info);
                if(this.store.member.needPwd){
                    this.removeBodyClick();
                    this.setState({showPwd: true });
                }else{
                    this.handleSettle();
                }
            } else {
                Message.toast('会员信息不存在')
            }
        })
    }
    validePwd = async (value)=> {
    //密码校验
        const result= await this.store.validePwd(value);
        if(result==""){//成功
            //返回
            this.setState({showPwd: false })
            this.store.authCode=value;
            this.handleSettle();
        }else{
            Message.toast(result);
        }
    }

    onTabsClick=(mode,czkenabled)=>{
        if(mode.paymentType==PayStyle.hyczk && czkenabled){
            this.store.setTheMode(mode);
            this.setState({showModal:true});
        }
    }

    renderToolbtn(mode,index,czkenabled){
        return (
          <div key={index+""} className={classnames({'paymode':true,'paymodeSelected':false,'paymodeDisabled':!czkenabled})} onClick={()=>{this.onTabsClick(mode,czkenabled)}}>
            <div className="logo"><div className="icon"><Ticon type={PayIcon[mode.paymentType]||PayIcon['default']}/></div></div>
            <div className="text">{mode.name.length>8?_truncate(mode.name,{length:7,omission:''})+'...':mode.name}</div>
          </div>
        )
      }
      getValue(retail,fieldName){
        let { voucherVM:{voucherDetail} } = stores.voucherStore;
            return common.formatValue(voucherDetail.find((column)=>column.FieldName==fieldName),retail[fieldName])
        }

      btnClick=()=>{
        stores.voucherStore.cancelSettle && stores.voucherStore.cancelSettle();
        history.push('/RE/RE01');
      }

      openLoadingModal =  ()=> {
        return modalShower({
          maskClosable: false,
          closable: false,
          width: '200px',
          content: <div className='billingSettling'>
            <div>
              <div className="ant-spin ant-spin-lg ant-spin-spinning"><span
                className="ant-spin-dot ant-spin-dot-spin"><i/><i/><i/><i/></span></div>
            </div>
            <div>支付中...</div>
          </div>
        })
      }

      handleSettle = async () =>{
        const payingModal=this.openLoadingModal();
        const result = await this.store.commit();
        if (result === true) {//成功
            //提示成功
            payingModal && payingModal.destroy();
            stores.voucherStore.settleSuccess && stores.voucherStore.settleSuccess({ openCashBox:false });
            history.push('/selfSuccess');
            Promise.resolve()
        }else{
            payingModal && payingModal.destroy();
            history.push('/selfFailure');
            await Promise.reject()
        }
      }
    
	render() {
        let {paymodes,amount,quantity,discount,member,czkenabled,quickmode}=this.store;
        let that=this;
        let { data:{dto} } = stores.voucherStore;
        let content=( 
            <div className="detailContent">
                <ul>
                    {dto.RetailDetails.map((retail, index) => {
                        let name = retail.Inventory && retail.Inventory.Name;
                        let taxPrice = this.getValue(retail,'TaxPrice') ;
                        let retailPrice =this.getValue(retail,'RetailPrice') ;
                        let quantity =this.getValue(retail,'Quantity') ;
                        let taxAmount = this.getValue(retail,'TaxAmount') ;

                        const select = false;
                        return <li key={retail.Code} className={`sku ${select ? 'sku-select' : ''}`} >

                            <div className='top'>
                                {retail.badge&&<Ticon type='zeng' className='zeng' />}
                                <span className='dname'>
                                    {name}
                                </span>
                            </div>

                            <div className='bottom'>
                                <span className='tax-price'>
                                    单价: ￥{taxPrice}
                                </span>
                                <span className={`retail-price ${taxPrice==retailPrice?'':'retail-price-through'}`}>
                                    原价: ￥{retailPrice}
                                </span>
                                <span className='dquantity'>
                                    X {quantity}
                                </span>
                                <span className='tax-amount'>
                                ￥{taxAmount}
                                </span>
                            </div>

                        </li>
                    })}
                </ul>
            </div>
        )
        let scanname=quickmode?(quickmode.paymentType==PayStyle.smzf?'微信或支付宝':quickmode.name):'';
		return (
        <div tabIndex='-1' className="selfSettle active-el">
            <div className="content">
                <div className="quantity">{`共${quantity}件`}</div>
                <div className="amount">{getFixedNumber(amount)}</div>
                {member && member.id &&<div className="member">
                    <span className="title">{member.type}</span>
                    <span className="value">{member.cardNo}</span>
                </div>}
                <div className="seperator">
                    <div className="left"></div>
                    <div className="middle"></div>
                    <div className="right"></div>
                </div>
                <div className="total">
                    <span className="title">商品金额</span>
                    <span className="value">{getFixedNumber(Math.Add(amount,discount))}</span>
                </div>
                <div className="discount">
                    <span className="title">优惠金额</span>
                    <span className="value">{getFixedNumber(discount)}</span>
                </div>
                <div className="detail">
                    <span className="value">
                        <Popover content={content}></Popover>
                    </span>
                </div>
                <div className="barcodecontainer"><div className="barcode"></div></div>
                <div className="tips1">{`请打开 ${scanname} 付款码`}</div>
                <div className="tips2">对准右下方扫描区</div>
                {_filter(paymodes,(mode)=>{return !mode.isQuick}).length>0 && <div className="otherpaymodes">其他支付方式</div>}
                <div className="paymodes">
                    {_map(_filter(paymodes,(mode)=>{return !mode.isQuick}),(mode,index)=>{
                        return this.renderToolbtn(mode,index,czkenabled)
                    })}
                </div>
                <div className="button">
                    <Button className="pay" onClick={this.btnClick}>取消支付</Button>
                </div>
            </div>
			<TipNumKbModalVertical
                className='member-tipmodal'
                visible={this.state.showModal}
                placeholder={'请输入储值卡号或手机号'}
                value={member && member.id ? member.cardNo: ''}
                cancel={() => {that.store.setQuickmode();that.setState({ showModal: false })}}
                title={'使用储值卡'}
                leftView={this.renderLeft}
                ok={(input) => {
                    this.searchMember(input);
                }}
            ></TipNumKbModalVertical>
            {this.state.showPwd && <PwdModal
                visible={this.state.showPwd}
                cancel={() => {that.store.setQuickmode();that.bindBodyClick();that.setState({showPwd: false })}}
                title={'储值卡密码'}
                placeholder={'请输入密码'}
                cardno={member && member.cardNo}
                balance={member && member.balance}
                ok={(val) => {
                    return this.validePwd(val)
                }}
            ></PwdModal>}
		</div>);
	}
}
